export const closeDropdown = (wrapper: HTMLDivElement | undefined): void => {
  if (wrapper) {
    const dropdown = wrapper.querySelector('modus-wc-dropdown-menu') as
      | (HTMLElement & { menuVisible?: boolean })
      | null;
    if (dropdown && 'menuVisible' in dropdown) {
      dropdown.menuVisible = false;
    }
  }
};
